import React from 'react'
import _ from 'lodash'

const Text = (s) => {
  if (!s)
    return null;

  const parts = s.split(':');
  if (parts.length === 1)
    return s;

  return (<span><strong>{parts[0]}:</strong>{parts[1]}</span>)
};

const Capabilities = (props) => (
  <span className="capability">{Text(props.text)}</span>
);

const SupplierInfoItem = (props) => {
  return (
    <div className="product-supplier-info-item">
      <div className="head clearfix">
        <div className="supplier-logo">
          <img src={props.logo} alt={props.title} />
        </div>
        <div className="supplier-description">
          <h3 className="title">{props.title}</h3>
          <div className="supplier-details">
            <ul>
              {props.details.map((d, idx) => <li key={idx}>{d}</li>)}
            </ul>
          </div>
        </div>
      </div>
      <div className="supplier-capabilities">
        <span className="title">Capabilities</span>
        {props.capabilities.map((c, idx) => <Capabilities key={idx} text={c} />)}
      </div>
      <div className="body">
        <table className="table specs">
          <tbody>
            {_.chunk(props.specs, 2).map((group, i) => (
                <tr key={i}>
                  {group.map((spec, j) => <td key={j} className="spec">{spec}</td>)}
                </tr>
              )
            )}
          </tbody>
        </table>
      </div>
    </div>
  )
};

SupplierInfoItem.defaultProps = {
  title: '',
  logo: null,
  rating: 0,
  details: [],
  capabilities: [],
  specs: []
};

export default SupplierInfoItem;
